import axios from 'axios';
import React from 'react';
import Select from 'react-select';

export default class LineOfBusinessToggle extends React.Component {
    constructor(props) {
        super(props);

        const lineOfBusiness = localStorage.getItem('lineOfBusiness');

        this.state = {
            lineOfBusiness,
            options: []
        };
    }

    handleLineOfBusinessChange = (e) => {
        if (e) {
            this.setState({ lineOfBusiness: e.value });
            localStorage.setItem('lineOfBusiness', e.value);
            window.location.reload(true);
        }
    }
 
    componentDidMount() {
     
        axios.get('/session/clientLOB')
        .then((response) => {

            const optionsArray = response.data.split(",").map(item => ({
                value: item.trim(),
                label: item.trim()
               }));
                const lineOfBusiness = localStorage.getItem('lineOfBusiness');
                if (!lineOfBusiness) {
                 localStorage.setItem('lineOfBusiness', optionsArray[0]?.value || '');
                 
            this.setState({ lineOfBusiness:  optionsArray[0]?.value || '' });
                }else{
                    if(!optionsArray.some(option =>  option.value == lineOfBusiness)){
                        localStorage.setItem('lineOfBusiness', optionsArray[0]?.value || '');
                        this.setState({ lineOfBusiness:  optionsArray[0]?.value || '' });
                    }else{
                        this.setState({ lineOfBusiness:  lineOfBusiness });

                    }   

                }
                
               this.setState({ options: optionsArray })
               
           
        }).catch((err)=>{
            console.log(err)
        })
    }
 

    render() {
        return (
            this.props.currentUser  ?
            <div className="nav-line-of-business-container">
                <Select value={this.state.lineOfBusiness} onChange={this.handleLineOfBusinessChange}
                    options={this.state.options} />
            </div> : null
        )
    }
}